<template>
  <div class="user-box" :class="{ 'user-box-bj': isLogin }">
    <template v-if="!isLogin">
      <div class="title-box">我的</div>

      <van-empty v-if="!$fn.isLogin()" class="custom-image" image="https://xhdata.wan4.com/wsw-h5-9.png"
        description="请登录后查看">
        <van-button class="on-btn" type="primary" to="/login">登录</van-button>
      </van-empty>
    </template>
    <template v-else>
      <div class="head-box">
        <div class="overlay" v-if="showPopover" @click="showPopover = false"></div>
        <div class="hub-pic">
          <img v-if="userData && userData.headImg" :src="userData.headImg || 'https://xhdata.wan4.com/wsw-pc-67.png'">
          <img v-else src="https://xhdata.wan4.com/wan4-head-pic.png">
        </div>
        <span class="hub-phone">{{ userData.mobile }}</span>
        <div class="hub-row">
          <span class="addr" @click="$router.push('/user/addressList')">地址管理</span>
          <i></i>
          <span class="kefu" @click="onKefuClick">在线客服</span>
        </div>
        <span class="quit" @click="quit">退出</span>

        <div class="tabs-box">
          <div class="row-box" ref="tabBox">
            <Badge v-for="item, index in tabs" :key="index" :content="getTabBadge(item.status)" :max="99">
              <span class="tab-box" ref="tabItem" :class="{ active: reqData.actStatus == item.status }"
                @click="setActStatus(item.status, $event)">{{ item.name }}</span>
            </Badge>
          </div>
          <i class="all-box" :class="{ 'all-box-active': showPopover }" @click="showPopover = true"></i>
        </div>
      </div>
      <div class="list-box" id="orderListBox">
        <div class="no-data" v-if="!list || list.length == 0">
          <img src="https://xhdata.wan4.com/wsw-h5-14.png" />
          <span>暂无{{ reqData.actStatus == 0 ? '' : tabs.filter(e => e.status == reqData.actStatus)[0].name }}订单！</span>
        </div>
        <List v-else v-model="loading" :finished="finished" v-back-to-top finished-text="没有更多了" :error.sync="error"
          error-text="网络异常，点击重新加载" @load="getData">
          <div class="order-item" v-for="item, index in list" :key="index">
            <div class="oi-title-box">
              <span @click="$router.push('/goods/shop?type=3&memCode=' + item.memCode)">工厂{{ item.memCode }}</span>
              <i v-if="item.actStaus == 2">待付款</i>
              <i v-if="item.actStaus == 3">待发货</i>
              <i v-if="item.actStaus == 4">待收货</i>
              <i v-if="item.actStaus == 6" style="color: #47C56A;">交易完成</i>
              <i v-if="item.actStaus == 7">交易关闭</i>
            </div>
            <div class="img-box" @click="toOrderDetals(item)">
              <VanImage class="img" fit="cover" v-for="img, index in item.goodsList" :key="index"
                :src="`${img}?1/w/150/h/150`" />
            </div>
            <div class="info-box">
              <span>数量：<i>{{ Number(item.buyQty).toLocaleString() }}</i></span>
              <span class="price">{{ item.actStaus == 2 || item.activeStaus == 71 ? '应付金额：' : '实付金额：' }}<i>{{
                $fn.initPrice(item.subTtlAmt, 0) }}</i><i>{{ $fn.initPrice(item.subTtlAmt, 1)
                  }}元</i></span>

              <van-button v-if="item.actStaus == 2" class="btn-pay" type="primary" @click="toOrderDetals(item)">去支付({{
                getTime(item.expireTick - time, item) }})</van-button>
              <van-button v-else class="btn-deltal" style="border-color: #999999;" lazy-load plain type="info"
                @click="toOrderDetals(item)">订单详情</van-button>
            </div>
          </div>
        </List>

        <van-popup v-model="showPopover" :round="true" style="position: absolute;"
          :overlay-style="{ position: 'absolute' }" position="top" :get-container="getContainer">
          <div class="popup-tabs">
            <span :class="{ active: reqData.actStatus == item.status }" v-for="item, index in tabs" :key="index"
              @click="onPopupTabClick(item.status, index)">{{ item.name }}</span>
          </div>
        </van-popup>
      </div>
    </template>


  </div>
</template>
<script>
import { Badge, List, Popup as vanPopup, Toast } from 'vant';
export default {
  name: 'User',
  components: {
    Badge, List, vanPopup
  },
  props: {},
  data() {
    return {
      isLogin: false,
      userData: null,
      reqData: {
        actStatus: 0,//0全部 2待付款 3待发货 4待收货 6已完成 7已关闭
        keyWords: '',//搜索关键字，按商品名称、商品编号、订单编号模糊匹配搜索
        page: 1,
        pageSize: 20,
      },
      info: {},//订单信息
      list: [],//订单列表
      loading: false,//是否处于加载状态，加载过程中不触发load事件
      finished: false,//是否已加载完成，加载完成后不再触发load事件
      error: false, //列表加载异常

      // tab
      tabs: [{ name: '全部', status: 0 }, { name: '待付款', status: 2 }, { name: '待发货', status: 3 }, { name: '待收货', status: 4 }, { name: '交易完成', status: 6 }, { name: '交易关闭', status: 7 }],
      showPopover: false,
      time: 0,//当前时间戳
    }
  },
  watch: {},
  computed: {},
  created() {
    this.time = new Date().getTime();
    setInterval(() => {
      this.time = new Date().getTime();
    }, 1000);
  },
  activated() {
    this.reqData.page = 1;
    this.initData();
  },
  methods: {
    getContainer() {
      return document.getElementById('orderListBox');
    },
    initData() {
      this.userData = this.$fn.getUserData();
      this.isLogin = this.$fn.isLogin();
      if (this.isLogin) {
        this.$fn.run(() => {
          this.userData = this.$fn.getUserData();
        })
        this.getData();
      }
    },
    getData() {
      this.loading = true;
      let toast = null;
      if (this.reqData.page == 1) {
        toast = Toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0,
          loadingType: 'spinner',
        });
      }
      this.$ajax('/iap-api/wan4/order/buyerOrderList.do', this.reqData).then(res => {
        toast && toast.clear()
        //防止测试疯狂切换tab 导致接口数据异常  只拿请求参数和 当前页面参数一样的
        if (JSON.stringify(res.params) != JSON.stringify(this.reqData)) {
          return
        }
        this.loading = false;
        res.data.waitPayTtl = res.data.waitPayTtl || ''
        res.data.waitDeliTtl = res.data.waitDeliTtl || ''
        res.data.waitRcvTtl = res.data.waitRcvTtl || ''
        this.info = res.data;
        if (res.params.page == 1) {
          this.list = res.data.rows;
        } else {
          this.list = [...this.list, ...res.data.rows];
        }
        this.reqData.page = res.params.page + 1;
        this.finished = this.list.length >= res.data.total;
      }, () => {
        this.loading = false;
        this.error = true;
        toast && toast.clear()
      })
    },
    getTabBadge(status) {
      let num = '';
      if (status == 2) {
        num = this.info.waitPayTtl ? this.info.waitPayTtl : '';
      } else if (status == 3) {
        num = this.info.waitDeliTtl ? this.info.waitDeliTtl : '';
      } else if (status == 4) {
        num = this.info.waitRcvTtl ? this.info.waitRcvTtl : '';
      }
      return num;
    },
    //倒计时
    getTime: function (time, item) {
      if (time < 0) {
        item.actStaus = 7;
        this.info.waitPayTtl = Number(this.info.waitPayTtl) - 1 <= 0 ? '' : Number(this.info.waitPayTtl) - 1;
        return
      }
      let ts = time / 1000
      let f = parseInt(ts / 60)
      f < 0 ? f = 0 : ''
      let s = parseInt(ts % 60)
      s < 10 ? s = '0' + s : ''
      return f + ':' + s
    },
    //弹框订单tab 切换 
    onPopupTabClick(status, index) {
      this.$refs.tabBox.scrollTo({ left: index <= 2 ? 0 : this.$refs.tabBox.offsetWidth, behavior: 'smooth' })
      this.showPopover = false;
      this.setActStatus(status)
    },
    //订单tab 切换 
    setActStatus(actStatus, e) {
      if (e) {
        // e.target.scrollIntoView({ behavior: 'smooth' , block: 'start', inline: 'start'})
      }
      this.reqData.actStatus = actStatus;
      this.reqData.page = 1
      this.getData();
    },
    onKefuClick() {
      window.location.href = 'https://300094.sh.absoloop.com/webim/im.html?configId=bda4de80-6e5c-11ef-b8aa-53197c42598f&language=zh-CN'
    },
    toOrderDetals(item) {
      // this.$toastUtil.show('联系开发')
      if (item.activeStaus == 21 || item.activeStaus == 71) {
        this.$router.push(`/order/details?paymentSn=${item.paymentSn}`)
      } else {
        this.$router.push(`/order/details?orderId=${item.orderId}`)
      }
    },
    quit() {
      this.$dialog.alert({
        message: `确定 <span style='font-weight: bold;'>退出登录</span> 吗?`
      }).then(() => {
        this.$fn.quit();
        this.initData();
      }).catch(() => {
      });
    }
  },
}
</script>
<style lang="less" scoped>
.user-box {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  margin-bottom: calc(env(safe-area-inset-bottom) + 96px);
  overflow: hidden;
  background: #fff;
  flex: 1;


  &-bj {
    background: linear-gradient(180deg, #FFF 7.51%, rgba(255, 246, 246, 0.94) 23.31%, rgba(224, 224, 224, 0.00) 100%);
  }

  .title-box {
    background: #fff;
    height: 88px;
    color: #333;
    font-size: 38px;
    font-style: normal;
    font-weight: bold;
    padding: 0 24px;
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    overflow: hidden;
  }

  .custom-image {
    margin-top: 88px;
  }


  .head-box {
    display: flex;
    flex-direction: column;
    position: relative;

    .overlay {
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      z-index: 2;
    }


    .hub-pic {
      width: 128px;
      height: 128px;
      border-radius: 50%;
      border: solid 2px #fff;
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      background: #d4d4d4;
      overflow: hidden;
      position: absolute;
      top: 20px;
      left: 32px;

      >img {
        width: 100%;
        height: 100%;
      }
    }

    .hub-phone {
      margin-left: 188px;
      margin-top: 34px;
      color: #333;
      font-size: 36px;
      font-style: normal;
      font-weight: bold;
      line-height: 50px;
    }

    .hub-row {
      display: flex;
      margin-left: 188px;
      margin-top: 2px;
      align-items: center;

      >span {
        display: flex;
        align-items: center;
        color: #333;
        font-size: 26px;
        font-style: normal;
        font-weight: 400;
        padding: 12px 0;
      }

      >i {
        width: 1px;
        height: 20px;
        background: #666;
        margin: 0 18px;
      }

      .addr {
        &::before {
          content: '';
          width: 32px;
          height: 32px;
          background: url('https://xhdata.wan4.com/wsw-h5-10.png') no-repeat center;
          background-size: 100% 100%;
          margin-right: 4px;
        }
      }

      .kefu {
        &::before {
          content: '';
          width: 32px;
          height: 32px;
          background: url('https://xhdata.wan4.com/wsw-h5-11.png') no-repeat center;
          background-size: 100% 100%;
          margin-right: 4px;
        }
      }
    }

    .quit {
      color: #999;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 34px;
      position: absolute;
      top: 32px;
      right: 32px;

      &::after {
        content: '';
        height: 1px;
        background: #999;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 1px;
      }
    }

    .tabs-box {
      display: flex;
      margin: 0 27px 0;
      position: relative;
      align-items: end;

      >* {
        flex-shrink: 0;
      }

      .row-box {
        display: flex;
        width: 0;
        flex: 1;
        overflow-x: auto;
        margin-right: 20px;
        padding-right: 5px;
        padding-top: 72px;
        -ms-overflow-style: none;
        /* IE 10+ */
        scrollbar-width: none;
        /* Firefox */

        &::-webkit-scrollbar {
          display: none;
          /* 针对Webkit浏览器隐藏滚动条 */
        }

        >* {
          margin-left: 38px;

          &:first-child {
            margin-left: 0;
          }
        }

        .tab-box {
          color: #333;
          font-size: 28px;
          font-style: normal;
          font-weight: 400;
          line-height: 40px;
          padding: 2px 5px;
          display: flex;
          align-items: center;
          flex-shrink: 0;
          white-space: nowrap;
        }

        .active {
          color: #FF6634;
          font-weight: 600;
          font-size: 32px;
          padding: 2px 0px;

        }

      }


      .all-box {
        width: 44px;
        height: 44px;
        background-color: #BBB;
        border-radius: 50%;
        background-image: url('https://xhdata.wan4.com/wsw-h5-13.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: 28px 28px;
        transition: 0.3s;

        &-active {
          transform: rotate(180deg);
        }
      }
    }
  }

  .list-box {
    margin: 24px 0 0;
    height: 0;
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .no-data {
      padding: 240px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;
      border-radius: 8px 8px 0 0;
      background: #FFF;
      margin: 0 18px;

      >img {
        width: 480px;
      }

      >span {
        color: #999;
        margin-top: 20px;
        font-size: 28px;
        font-style: normal;
        font-weight: 400;
        line-height: 40px;
      }
    }

    .van-list {
      padding: 0 18px;
      overflow-y: scroll;
    }

    .order-item {
      border-radius: 8px;
      background: #FFF;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      margin-top: 20px;
      flex-shrink: 0;

      &:first-child {
        margin-top: 0;
      }

      .oi-title-box {
        display: flex;
        height: 76px;
        border-bottom: 1px solid #E5E5E5;
        align-items: center;
        position: relative;

        >span {
          color: #333;
          font-size: 28px;
          font-style: normal;
          font-weight: 600;
          margin-left: 24px;
          display: flex;
          align-items: center;

          &::after {
            content: '';
            width: 28px;
            height: 28px;
            margin-left: 2px;
            background: url('https://xhdata.wan4.com/wsw-h5-12.png') no-repeat center;
            background-size: 100%;
          }
        }

        >i {
          color: #FF6634;
          font-size: 28px;
          font-style: normal;
          font-weight: bold;
          position: absolute;
          right: 24px;
        }
      }

      .img-box {
        display: flex;
        padding: 24px 0 18px;
        margin: 0 24px;
        overflow: hidden;

        .img {
          width: 144px;
          height: 144px;
          border-radius: 8px;
          overflow: hidden;
          border: 2px solid #DCDCDC;
          margin-left: 24px;
          flex-shrink: 0;

          &:first-child {
            margin-left: 0;
          }
        }
      }

      .info-box {
        display: flex;
        flex-direction: column;
        margin: 0 24px 24px;
        position: relative;

        >span {
          color: #999;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 34px;

          >i {
            color: #333;
            font-weight: bold;
          }
        }

        .price {
          margin-top: 4px;
          line-height: 44px;

          >i {
            color: #f53f3f;
            font-size: 32px;
            font-style: normal;
            font-weight: bold;
          }

          >i+i {
            color: #f53f3f;
            font-size: 24px;
            font-style: normal;
            font-weight: bold;
          }
        }

        .btn-pay {
          position: absolute;
          right: 0;
          bottom: 0;
          height: 76px;
          width: 242px;
          font-size: 28px;
          font-weight: bold;
          border-radius: 8px;
        }

        .btn-deltal {
          position: absolute;
          right: 0;
          bottom: 0;
          height: 64px;
          padding: 0 32px;
          border-radius: 8px;
          background: #fff;
        }
      }
    }
  }


}

.popup-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 18px 18px;
  padding: 32px;


  >span {
    border-radius: 4px;
    border: 2px solid #F8F8F8;
    width: 158px;
    height: 68px;
    background: #F8F8F8;
    color: #333;
    font-size: 26px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .active {
    color: #FFF;
    background: #FF6634;
    font-weight: bold;
  }
}
</style>